<template>
	<div class="setup-section">
    <div class="setup">
      <h3>Настройки</h3>
      <settings></settings>
      <button class="uk-button uk-button-primary" @click="letStart">СТАРТ!</button>
    </div>
    		
		<div class="setup__description">
			<div class="wh-block__desc" v-html="item.instruction"></div>
			<div class="wh-block__pic"><img v-if="item.inner_image" :src="item.inner_image.path" alt=""></div>
		</div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import Select2 from 'v-select2-component';
  import settings from "./components/Settings";

  export default {
    name: "instructions",
    components: { Select2, settings },
    computed: {
      params(){
        return this.$store.state.train.texts_params;
      },
      ...mapState({
        item: 'current_trainer'
      })
    },
    methods: {
      letStart(){
        console.log('Let Start');
        if(this.params.text){
          this.$parent.commitVal(true, 'start')
        } else {
          swal('Выберите текст', '', 'error');
        }
      }
    }
  }
</script>
